import useManyRemoteM1 from '@aims/shared/shared/use-many-remote-m1';
import { gql } from '@apollo/client';
import { useRef, useState } from 'react';
import settings from '../../settings';

const query = gql`
  query allHolisticProjectsForUser(
    $first: Int
    $after: String
    $filters: HolisticProjectFiltersForUser
    $sortBy: [SortBy]
  ) {
    allHolisticProjectsForUser(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          _id
          regionCode
          region
          peopleGroupIds
          peopleGroups {
            _id
            nameAcrossCountries
            country
          }
          projectName
          typeOfProject
          desc
          stage
          primaryThumbnailUrl
          tags {
            key
            color
          }
          createdAt
          updatedAt
          deletedAt
          projectNo
        }
      }
    }
  }
`;

const extract = (data) => data?.allHolisticProjectsForUser;

export function useAllHolisticProjects({ filters, queryId, skip }) {
  const [sortedBy, setSortedBy] = useState('projectName.keyword');
  const [sortOrder, setSortOrder] = useState('ASC');

  const sortBy = useRef([
    { key: sortedBy, order: sortOrder },
    { key: '_score', order: 'DESC' },
  ]);

  const { error, loading, data, search, hasNextPage, next, refetch, reset } =
    useManyRemoteM1({
      query,
      extract,
      first: settings.querySize,
      filters,
      sortBy: sortBy.current,
      fetchPolicy: 'network-only',
      queryId,
      skip,
    });
  return {
    error,
    loading,
    data,
    search,
    hasNextPage,
    next,
    refetch,
    reset,
  };
}
